var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button } from '@ui';
import { Text } from '@ui/atoms/Text';
import { Tag } from '@ui/atoms/Tag';
import { translate } from '@utils/i18n';
import { UserAccessTable } from '../UserAccessTable';
import { UserAccessModal } from '../UserAccessModal';
import './UserAccessSectionStyles.scss';
const namespace = 'features.settings.ip_assistant';
function UserAccessSection({ allowedUserIds, allowedTechnicianIds, maxUsers, disabled = false, onSave, isSaving }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const enabledCount = allowedUserIds.length + allowedTechnicianIds.length;
    const handleEditClick = () => {
        setIsModalOpen(true);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleModalSave = (userIds, technicianIds) => __awaiter(this, void 0, void 0, function* () {
        yield onSave(userIds, technicianIds);
        setIsModalOpen(false);
    });
    return (React.createElement("section", { className: `ip-assistant-user-access-section${disabled ? ' ip-assistant-user-access-section--disabled' : ''}` },
        React.createElement("div", { className: "ip-assistant-user-access-section__header" },
            React.createElement("div", { className: "ip-assistant-user-access-section__header-left" },
                React.createElement(Text, { variant: "medium", as: "h2" }, translate('user_access_title', { namespace })),
                React.createElement(Tag, { label: translate('user_access_badge', { namespace, count: enabledCount, max: maxUsers }) })),
            React.createElement(Button, { onClick: handleEditClick, disabled: disabled },
                React.createElement("i", { className: "fa-light fa-pencil" }),
                " ",
                translate('edit', { namespace }))),
        enabledCount === 0 ? (React.createElement("div", { className: "ip-assistant-user-access-section__empty-state" },
            React.createElement(Text, { variant: "body" }, translate('empty_state', { namespace })))) : (React.createElement(UserAccessTable, null)),
        isModalOpen && (React.createElement(UserAccessModal, { isOpen: isModalOpen, onClose: handleModalClose, onSave: handleModalSave, allowedUserIds: allowedUserIds, allowedTechnicianIds: allowedTechnicianIds, maxUsers: maxUsers, isSaving: isSaving }))));
}
export default UserAccessSection;
